import { Component, ViewChild, TemplateRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PageEvent } from "@angular/material/paginator";
import {
    BaseComponent,
    ActionDialog,
} from "../../base-module/base-component/base.component";
import { AuthService } from "app/base-module/base-service/auth.service";
import { TipoConsorcioService } from "../services/tipo-consorcio.service";
import { CadastroTipoConsorcioComponent } from "../cadastro-tipo-consorcio/cadastro-tipo-consorcio.component";

@Component({
    selector: "app-lista-tipo-consorcio",
    templateUrl: "./lista-tipo-consorcio.component.html",
    styleUrls: ["./lista-tipo-consorcio.component.scss"],
})
export class ListaTipoCosorcioComponent extends BaseComponent {
    user: any;

    @ViewChild("addButtonTmpl", { static: false })
    addButtonTmpl!: TemplateRef<any>;
    @ViewChild(ListaTipoCosorcioComponent, { static: false })
    table!: ListaTipoCosorcioComponent;

    constructor(
        public _service: TipoConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private _authService: AuthService
    ) {
        super(dialog, snackBar);

        this.getAll();
        const strUser = this._authService.getUser();
        this.user = JSON.parse(strUser ? strUser : "{}");
    }

    /**
     * Evento da paginação
     * @param {PageEvent} event
     */
    pageEvent(event: PageEvent) {
        console.log(event);

        this.params.page = event.pageIndex + 1;
        this.params.per_page = event.pageSize;

        this.getAll();
    }

    /**
     * Consulta lista de Tipo de Consórcio
     */
    getAll(): void {
        this.loadingIndicator = true;
        this._service.getAll(this.params).subscribe(
            (data) => {
                this.length = data.meta?.total ?? 0;
                this.rows = data.data ?? [];
                this.temp = [...this.rows];
            },
            (error) => {
                console.log("error: " + error);
                this.loadingIndicator = false;
            },
            () => {
                console.log("complete");
                this.loadingIndicator = false;
            }
        );
    }

    /**
     * Exclui Tipo de Consórcio
     * @param id
     */
    delete(id: number) {
        const lista = this;
        this.dialog.open(ActionDialog, {
            width: "250px",
            disableClose: true,
            data: {
                title: "Excluir Tipo de Consórcio",
                text: "Deseja realmente excluir este item?",
                callback: function () {
                    lista.dialog.closeAll();

                    lista.loadingIndicator = true;
                    lista._service.delete(id).subscribe(
                        (data) => {
                            lista.loadingIndicator = false;
                            lista.showSuccess(data.message);
                            lista.getAll();
                        },
                        (error) => {
                            lista.closeLoading();
                            console.log("error: " + error);
                            lista.showError(error.message);
                        },
                        () => {
                            console.log("complete");
                            lista.loadingIndicator = false;
                        }
                    );
                },
            },
        });
    }

    /**
     * Modal de cadastro
     */
    openCadastro(): void {
        const dialogRef = this.dialog.open(CadastroTipoConsorcioComponent, {
            width: "400px",
            height: "80%",
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Tipo de Consórcio cadastrado com sucesso!");
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError(
                    "Ocorreu um erro ao tentar cadastrar um novo registro."
                );
            }
        });
    }

    /**
     * Modal de edição
     */
    openAlterar(id: number): void {
        const dialogRef = this.dialog.open(CadastroTipoConsorcioComponent, {
            width: "400px",
            height: "80%",
            data: {
                id: id,
            },
        });

        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != undefined && result != null && result != "cancel") {
                this.showSuccess("Tipo de Consórcio atualizado com sucesso!");
                this.getAll();
            } else if (result != undefined && result != "cancel") {
                this.showError("Ocorreu um erro ao tentar altera o registro");
            }
        });
    }
}
